import { render, staticRenderFns } from "./VerifyBox.vue?vue&type=template&id=9700a70e&"
import script from "./VerifyBox.vue?vue&type=script&lang=ts&"
export * from "./VerifyBox.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
